import fetch,{ postFrom ,getBlob} from '../utils/fetch';

export function targetList(params){
  return fetch({
    method: 'POST',
    url: '/perGoalEstimation/list',
    data:params
  })
}

export function deleteTaregt(params){
  return fetch({
    method: 'GET',
    url: '/perGoalEstimation/delete',
    params
  })
}
export function saveTarget(params){
  return fetch({
    method: 'POST',
    url: '/perGoalEstimation/save',
    data:params
  })
}

export function updateTarget(params){
  return fetch({
    method: 'POST',
    url: '/perGoalEstimation/update',
    data:params
  })
}
//费用
export function condition(params) {
  return fetch({
    method: 'GET',
    url: '/incomeCostItem/businessCode/condition',
    params
  })
}
  //类型
  export function getType(params){
    return fetch({
      method: 'GET',
      url: '/perGoalEstimation/getType',
      params
    })
}

//
export function getBudgetCode(params){
	return fetch({
    method:'GET',
    url:'/perGoalEstimation/getBudgetCode',
    params
  })
}